const { default: CommonServices } = require("./common/common");

class BhaktiSangeetManagementService extends CommonServices {
  constructor() {
    super("/bhaktisangeet");
  }
}

const bhaktiSangeetManagementService = new BhaktiSangeetManagementService();
export default bhaktiSangeetManagementService;
